export default __webpack_public_path__ + "static/media/video.910e8a45.mp4";